module.exports = __webpack_public_path__ + "img/LogoMaranatha.b4036f01.png";